import React from 'react'
import styles from '../registration.module.scss'
import WTNSpinner from 'components/generic/WTNSpinner'

const LoadingSpinner = () => {
  return (
    <div className={styles.loadingContainer}>
      <WTNSpinner width={90} />
    </div>
  )
}

export default LoadingSpinner
